__turbopack_context__.v({
  "bar": "LpHeader-module__pOxBxq__bar",
  "barOpen1": "LpHeader-module__pOxBxq__barOpen1",
  "barOpen2": "LpHeader-module__pOxBxq__barOpen2",
  "barOpen3": "LpHeader-module__pOxBxq__barOpen3",
  "container": "LpHeader-module__pOxBxq__container",
  "desktopCta": "LpHeader-module__pOxBxq__desktopCta",
  "hamburger": "LpHeader-module__pOxBxq__hamburger",
  "header": "LpHeader-module__pOxBxq__header",
  "logo": "LpHeader-module__pOxBxq__logo",
  "logoButton": "LpHeader-module__pOxBxq__logoButton",
  "logoContainer": "LpHeader-module__pOxBxq__logoContainer",
  "mobileCta": "LpHeader-module__pOxBxq__mobileCta",
  "nav": "LpHeader-module__pOxBxq__nav",
  "navContainer": "LpHeader-module__pOxBxq__navContainer",
  "navItem": "LpHeader-module__pOxBxq__navItem",
  "navOpen": "LpHeader-module__pOxBxq__navOpen",
  "navText": "LpHeader-module__pOxBxq__navText",
});
